/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AdEnginePlugin } from "./AdEnginePlugin";
import { reportError } from "../helpers/observability";

type AdEnginePluginHooks = AdEnginePlugin["hooks"];

export function runHook<T extends keyof AdEnginePluginHooks>(
  plugins: AdEnginePlugin[],
  hookName: T,
  ...args: Parameters<NonNullable<AdEnginePluginHooks[T]>>
): void {
  for (const plugin of plugins) {
    const hook = plugin.hooks[hookName];

    // If the plugin has the hook, call it with the provided arguments
    if (typeof hook === "function") {
      try {
        (hook as any).call(plugin, ...args);
      } catch (error) {
        console.error(
          `Error running hook ${hookName} in plugin ${plugin.constructor.name}`,
          error,
        );
        void reportError(error);
      }
    }
  }
}
